























































declare var window: any;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from './../store.vuex';
import router from '../router';

@Component
export default class AppBanner extends Vue {
  @Prop() onClose;
  get appstoreUrl() {
    return window.WorkLLama.workllamaIosAppUrl;
  }

  get companyCode() {
    return vxm.jobs.BrandingInfo.companycode;
  }

  get playstoreUrl() {
    return window.WorkLLama.workllamaAndroidAppUrl;
  }
  get referralBannerURL() {
    return `${vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    )}/${vxm.jobs.BrandingInfo.companycode}/CANDIDATEPORTAL/ic_referbanner.png`;
  }

  get appBannerText() {
    //return this.$t('app.banner.text');
    const bannerText = vxm.configs.getGlobalConfigValue('TALENT_PORTAL_BANNER_TEXT');
    return bannerText !== '<div><br></div>' ? bannerText : '';
  }

  get isAppLinkDisabled() { 
    return !vxm.jobs.BrandingInfo.DISABLE_APPLINK_IN_BANNER;
  }
}
